export const menu = {
  sx: {
    minWidth: "200px",
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 28,
      height: 28,
      ml: -0.5,
      mr: 1.65,
    },
    "& .MuiListItemIcon-root": {
      ml: 0.15,
    },

    // Arrow
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 23,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};
